import { PublicAccount, VaultItem } from "@cede/types";
import { CedeProvider } from "@cedelabs/providers/src";
import { create } from "zustand";

export type PublicAccountWithVaultId = PublicAccount & { vaultId: string };

type CedeStoreState = {
  vaults: VaultItem[];
  activeVault: VaultItem | null;
  accounts: PublicAccountWithVaultId[];
  setVaults: (vaults: VaultItem[]) => void;

  provider: CedeProvider | null;
  setProvider: (provider: CedeProvider) => void;
};

// TODO: unify in the useCedeStore hooks package
export const useCedeStore = create<CedeStoreState>((set) => ({
  vaults: [],
  activeVault: null,
  accounts: [],
  setVaults: (vaults: VaultItem[]) =>
    set({
      vaults,
      activeVault: vaults.find((vault) => vault.isActive) || null,
      accounts: vaults.flatMap((vault) => vault.accounts.map((acc) => ({ ...acc, vaultId: vault.id }))),
    }),

  provider: null,
  setProvider: (provider: CedeProvider) => set({ provider }),
}));
